import type { ReactNode } from 'react'
import { FlashMessages } from '@/components/FlashMessages'

interface GuestLayoutProps {
  children: ReactNode
}

export default function GuestLayout({ children }: GuestLayoutProps) {
  return (
    <main className="flex min-h-screen">
      {/* Left side — brand panel */}
      <div className="hidden lg:flex lg:w-[45%] flex-col justify-between bg-primary p-10">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-white/20">
            <span className="text-sm font-bold text-white">N</span>
          </div>
          <span className="text-lg font-semibold tracking-tight text-white">Nest</span>
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-semibold leading-snug text-white tracking-tight">
            Financial management,<br />
            simplified.
          </h1>
          <p className="text-[15px] leading-relaxed text-white/60 max-w-sm">
            Track transactions, manage invoices, and gain insights into your business finances.
          </p>
        </div>

        <p className="text-xs text-white/40">
          Your financial data is securely stored and encrypted.
        </p>
      </div>

      {/* Right side — form */}
      <div className="flex w-full lg:w-[55%] flex-col items-center justify-center px-6 py-12 bg-background">
        <div className="w-full max-w-[360px]">
          {/* Mobile logo */}
          <div className="mb-8 lg:hidden flex items-center justify-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary">
              <span className="text-sm font-bold text-primary-foreground">N</span>
            </div>
            <span className="text-lg font-semibold text-foreground">Nest</span>
          </div>

          <FlashMessages />
          {children}
        </div>
      </div>
    </main>
  )
}
